import { useConnectWallet } from '@privy-io/react-auth'

import { classifyError } from './classifyError'
import { track } from './events'

function getWalletConnectErrorMessage(error: unknown): string {
  return error instanceof Error ? error.message : String(error)
}

export function trackWalletConnectFailed(error: unknown): void {
  track('wallet_connect_failed', {
    error_type: classifyError(error),
    error_message: getWalletConnectErrorMessage(error),
  })
}

export async function triggerWalletConnect(connectWallet: () => Promise<void> | void, source: string): Promise<void> {
  track('wallet_connect_clicked', { source })

  try {
    await Promise.resolve(connectWallet())
  } catch (error) {
    trackWalletConnectFailed(error)
  }
}

export function useTrackedWalletConnect(source: string): () => void {
  const { connectWallet } = useConnectWallet({
    onError: (error) => {
      trackWalletConnectFailed(error)
    },
  })

  return () => {
    track('wallet_connect_clicked', { source })
    connectWallet()
  }
}
